import React, { useState, useEffect } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { postDeclineArchiveURL } from "../utils/api";
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Text,
    RadioGroup,
    Radio,
    HStack,
    Box,
    InputRightElement,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
  } from "@chakra-ui/react";

function DeclineArchive({
    isOpen,
    onClose,
    successCallback,
    archiveData
}) {

    const { auth } = useAuth();
    const [ errors, setErrors ] = useState([]);
    const [ submitting, setSubmitting ] = useState(false);

    const postArchive = (e) => {
        e.preventDefault();

        setErrors([]);
        setSubmitting(true);
        // console.log(email, password);
        axios.post( postDeclineArchiveURL(archiveData.id), 
        {
            
        },{
            headers: {
                Authorization: `Bearer ${auth.authToken}`
            }
        }).then(result => {
            if (result.status === 200) {
                // const roles = result.data.data.user.roles;
                const user = result.data.data;
                // console.log(user);
                if (successCallback) {
                    successCallback();
                }
                onClose();
            } else {
                setErrors(result.data.errors);
            }
        }).catch(e => {
            if (e.response === undefined) {
                setErrors(['Could not connect to server!'])
            } else {
                setErrors(e.response.data.errors)
            }
        }).finally(e => {
            setSubmitting(false);
        });
    }

    if (!archiveData) {
        return (<></>);
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
            <ModalHeader>Decline Archive Request</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                <form onSubmit={postArchive}>


                    <FormControl >

                    <Flex w="100%" flexDir="column">

                        <Text 
                            fontSize="16px"
                            color={"black"}
                            textAlign="start"
                        >
                            Name: {archiveData.product.name}
                        </Text>

                        <Text 
                            fontSize="16px"
                            color={"black"}
                            textAlign="start"
                        >
                            Description: {archiveData.product.description}
                        </Text>
                                 
                        <Text 
                            fontSize="14px"
                            color={"orange"}
                            textAlign="start"
                        >
                            Requested By: {archiveData.requestor.firstName} {archiveData.requestor.lastName}
                        </Text>

                        <Text 
                            fontSize="14px"
                            color={"black"}
                            textAlign="start"
                        >
                            Comment: {archiveData.requestedComment}
                        </Text>
                                 
                       <Text 
                            fontSize="14px"
                            color={"grey"}
                            textAlign="start"
                        >
                            Requested at: {new Date(archiveData.requestedAt).toLocaleString()}
                        </Text>
                            
                    </Flex>
                   
                    <Flex w="100%" flexDir="column" marginBottom="12px">
                        { errors.length > 0 && <Text color="red">{errors[0]}</Text> }
                    </Flex>

                    <Button
                        fontSize="10px"
                        type="submit"
                        bg="teal.300"
                        w="100%"
                        h="45"
                        mb="20px"
                        color="white"
                        mt="0px"
                        _hover={{
                        bg: "teal.200",
                        }}
                        _active={{
                        bg: "teal.400",
                        }}
                        isDisabled={submitting}
                    >
                        DECLINE
                    </Button>
                    

                </FormControl>
            </form>
            </ModalBody>
            {/* <ModalFooter>
                <Flex w="100%"
                flexDirection={{
                sm: "row",
                md: "row",
                }} 
                alignItems={{ xl: "center" }}>
                <Button variant="ghost" onClick={onClose}>Cancel</Button>
                <Spacer />
                <Button colorScheme="teal" mr={3} >
                    Submit
                </Button>
                </Flex>
            </ModalFooter> */}
            </ModalContent>
        </Modal>
    );

}



export default DeclineArchive;
